export default __webpack_public_path__ + "static/media/03_establishing.e675d5bf.jpg";